import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=5b30a4fc&scoped=true&"
import script from "./Metadata.vue?vue&type=script&lang=ts&"
export * from "./Metadata.vue?vue&type=script&lang=ts&"
import style0 from "./Metadata.vue?vue&type=style&index=0&id=5b30a4fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30a4fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
